<template>
<div class="chapter">
<div class="inner_page">
<div class="map">
<p class="ct_no_cn"><span epub:type="pagebreak" id="pageix" title="ix"></span><a href="#/Text/Contents#Map"><span class="blue">Tham Luang Cave Complex Map</span></a></p>
<figure class="map">
<span epub:type="pagebreak" id="pagex" title="x"></span><img alt="" src="Images/Map1.jpg"/>
</figure>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Map.vue?7133df98